import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'VIDEO_RESUME_URL_GET',
  GET_SUCCESS: 'VIDEO_RESUME_URL_GET_SUCCESS',
  GET_FAILURE: 'VIDEO_RESUME_URL_GET_FAILURE',

  POST: 'VIDEO_RESUME_URL_POST',
  POST_SUCCESS: 'VIDEO_RESUME_URL_POST_SUCCESS',
  POST_FAILURE: 'VIDEO_RESUME_URL_POST_FAILURE',
};

export const get = actions.get(userId => `${BASE_URL}/students/${userId}/video-link/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const post = actions.post(
  (id, { userId }) => `${BASE_URL}/students/${userId}/video-link/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
